export const END_DATES_VALIDATOR: {[name: string]: number} = {
  '3M': 3,
};

export const PAGE_SIZE = 10;
